module.exports = __webpack_public_path__ + "static/media/fullstack.c236bec2.svg";